module.exports = __webpack_public_path__ + "img/SpectrumPoster - Keys.4180f6cc.jpg";